<section class="py-7 section-content bg-black text-white">
  <div class="container-xl">
    <div class="row">
      <div class="col-12 col-lg-4 mb-2 mb-lg-0 text-md-start text-center">
        <p class="text-uppercase fs-lg ls-1 mb-0">Helping Charities Win</p>
        <h2 class="h1 text-white">Our Results Don't Lie</h2>
      </div>
      <div class="col-12 col-lg-8">
        <div class="row h-100 align-items-center text-center justify-content-center g-4">
          <div class="col-12 col-sm-4 text-center text-md-start">
            <h3 class="h1 text-white mb-0">2,000+</h3>
            <p class="m-0">Charities Served</p>
          </div>
          <div class="col-12 col-sm-4 text-center text-md-start">
            <h3 class="h1 text-white mb-0">$15MM</h3>
            <p class="m-0">Raised for Causes</p>
          </div>
          <div class="col-12 col-sm-4 text-center text-md-start">
            <h3 class="h1 text-white mb-0">10,000+</h3>
            <p class="m-0">Happy Donors</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
